/* eslint-disable no-plusplus */
import { subYears, getYear, parse, isAfter, format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

import { store } from '~/store';

export function getEveryMonth() {
  const months = [];
  let i;

  for (i = 0; i < 12; i++) {
    months.push(ptBR.localize.month(i));
  }

  return months;
}

export function getYearsInterval(interval) {
  const years = [];
  let i;

  for (i = interval; i >= 0; i--) {
    years.push(getYear(subYears(new Date(), i)));
  }

  return years.sort((a, b) => b - a);
}

export function compareIsAfterDates({
  current,
  compare,
  format = 'dd/MM/yyyy HH:mm:ss',
}) {
  const dateNow = parse(current, format, new Date());
  const dateCompare = parse(compare, format, new Date());

  return isAfter(dateNow, dateCompare);
}

function parseDateBR(dateStr) {
  if (!dateStr) return null;

  const [datePart, timePart] = dateStr.split(' ');

  if (!datePart || !timePart) return null;

  const [dia, mes, ano] = datePart.split('/').map(Number);
  const [hora, minuto, segundo] = timePart.split(':').map(Number);

  const date = new Date(ano, mes - 1, dia, hora, minuto, segundo);

  // Validação: conferir se voltou igual (trata datas inválidas)
  if (
    date.getFullYear() !== ano ||
    date.getMonth() !== mes - 1 ||
    date.getDate() !== dia ||
    date.getHours() !== hora ||
    date.getMinutes() !== minuto ||
    date.getSeconds() !== segundo
  ) {
    return null;
  }

  return date;
}

export function compareIsAfterSDates(dateStr1, dateStr2) {
  const d1 = parseDateBR(dateStr1);
  const d2 = parseDateBR(dateStr2);

  if (!d1 || !d2) {
    console.error('Erro: uma das datas é inválida');
    return false;
  }

  return d2 > d1; // true se data2 é maior que data1
}

export function compareIsBeforeSDates(dateStr1, dateStr2) {
  const d1 = parseDateBR(dateStr1);
  const d2 = parseDateBR(dateStr2);

  if (!d1 || !d2) {
    console.error('Erro: uma das datas é inválida');
    return false;
  }

  return d2 < d1; // true se data2 é menor que data1
}

export function formatISO({ date, output = 'dd/MM/yyyy HH:mm' }) {
  if (date) {
    return format(parseISO(date), output);
  }

  return date;
}

export function transformDateYup(date) {
  const { language } = store.getState().user;

  const formatDate = ['pt-BR', 'es-CL', 'es-ES'].includes(language)
    ? 'dd/MM/yyyy HH:mm:ss'
    : 'yyyy-MM-dd HH:mm:ss';

  return parse(date, formatDate, new Date());
}
